import cx from "clsx";
import React from "react";

import Content from "./containers/Content";
import { useGallerySidebarApi } from "./hooks/useGallerySidebarApi";
import styles from "./index.module.scss";

type RootProps = {
  className?: string;
  style?: React.CSSProperties;
  api: ReturnType<typeof useGallerySidebarApi>;
};

export default function GallerySidebar({ className, style, api }: RootProps) {
  const [collapsedDesktop, setCollapsedDesktop] = React.useState(false);
  const [collapsedMobile, setCollapsedMobile] = React.useState(true);

  return (
    <aside className={cx(styles.container, className)} style={style}>
      {/* 1. Expanded on mobile */}
      <div
        className={cx(
          styles.drawer,
          styles.onlyOnMobile,
          collapsedMobile ? styles.hidden : undefined
        )}
      >
        <div
          className={styles.drawerBackdrop}
          onClick={() => setCollapsedMobile(true)}
        ></div>
        <div className={styles.drawerMain}>
          <Content
            variant="expanded"
            api={api}
            toggleCollapse={() => setCollapsedMobile(true)}
          />
        </div>
      </div>
      {/* 2. Collapsed on mobile */}
      <Content
        className={cx(styles.onlyOnMobile, styles.contentCollapsed)}
        variant="collapsed"
        api={api}
        toggleCollapse={() => setCollapsedMobile(false)}
      />
      {/* 3. Collapsed on desktop */}
      <Content
        className={cx(
          styles.onlyOnDesktop,
          !collapsedDesktop ? styles.hidden : undefined,
          styles.contentCollapsed
        )}
        variant="collapsed"
        api={api}
        toggleCollapse={() => setCollapsedDesktop(false)}
      />
      {/* 4. Expanded on desktop */}
      <Content
        className={cx(
          styles.onlyOnDesktop,
          collapsedDesktop ? styles.hidden : undefined,
          styles.contentExpanded
        )}
        variant="expanded"
        api={api}
        toggleCollapse={() => setCollapsedDesktop(true)}
      />
    </aside>
  );
}
